import React from "react";
import { injectIntl } from "react-intl";
import { AutocompleteSelect } from "components/autocomplete";
import PropTypes from "prop-types";
import { query as deploymentsQuery } from "pages/deployment";
import FormFieldError from "components/form/form-field-error";
import { useCurrentCustomerContext } from "components/current-customer-context";

const DeploymentAutocompleteSelect = ({ id, name, placeholder, label, onChange, intl, value }) => {
  const { currentCustomerId } = useCurrentCustomerContext();
  return (
    <>
      <AutocompleteSelect
        id={id}
        gqlQuery={deploymentsQuery}
        variables={{ customerId: currentCustomerId }}
        getElementsFromDataHandler={data =>
          data.deployments
            ? data.deployments.items.map(deployment => ({
                label: deployment.description,
                value: deployment.id,
              }))
            : []
        }
        placeholder={placeholder}
        onChange={item => (item ? onChange(name)(item.value) : onChange(name)(""))}
        label={label}
        value={value}
      />
      <FormFieldError name={name} />
    </>
  );
};

DeploymentAutocompleteSelect.propTypes = {
  /**
   * Id del input
   */
  id: PropTypes.string,
  /**
   * Valor del input
   */
  value: PropTypes.string,
  /**
   * Name del input
   */
  name: PropTypes.string,
  /**
   * Placeholder del input
   */
  placeholder: PropTypes.string,
  /**
   * Label del input
   */
  label: PropTypes.string,
  /**
   * Callback que se dispara con el cambio del input
   */
  onChange: PropTypes.func,
};

export default injectIntl(DeploymentAutocompleteSelect);
